<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Sync Logs</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <div class="row align-items-center">
      <div class="col-md-2 title-left">Job Name</div>
      <div class="col-md-5 pl-md-0 fit-content">
        <select class="custom-select" v-model="jobName">
          <option value>All</option>
          <option value="Sync">Sync</option>
          <option value="SyncBenefitOption">SyncBenefitOption</option>
          <option value="SyncLeave">SyncLeave</option>
          <option value="SyncReport">SyncReport</option>
          <option value="SyncRoster">SyncRoster</option>
          <option value="SyncTimesheetImportedHours">
            SyncTimesheetImportedHours
          </option>
          <option value="UploadChangeReportForInsuranceDependentEnrolment">
            UploadChangeReportForInsuranceDependentEnrolment
          </option>
        </select>
      </div>

      <div class="col-md-1 title-right ml-3">Status</div>
      <div class="col-md-2 pl-md-0 fit-content">
        <select class="custom-select" v-model="status">
          <option value>All</option>
          <option value="Success">Success</option>
          <option value="Fail">Fail</option>
        </select>
      </div>
    </div>
    <div class="row align-items-center mt-2">
      <div class="col-md-2 title-left">Date From</div>
      <div class="col-md-2 pl-md-0 fit-content">
        <input type="date" class="form-control" v-model="dateFrom" />
      </div>
      <div class="col-md-1 fit-content">Date To</div>
      <div class="col-md-2 pl-md-0 fit-content">
        <input
          type="date"
          class="form-control"
          v-model="dateTo"
          :min="dateFrom"
        />
      </div>
      <div class="col-md-2 ml-5">
        <button class="btn btn-primary" @click="getLogs">Search</button>
      </div>
    </div>
    <!-- /Form -->

    <!-- Pagination -->
    <div class="row mt-4">
      <div class="col-md-6">
        Show
        <select
          class="custom-select"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1 mt-2">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="date-column">Processed Date Time</th>
                <th class="jobname-column">Job Name</th>
                <th class="date-column">Date Time End</th>
                <th class="status-column">Status</th>
                <th class="error-column">Success/Error Message</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in logs" :key="item.Id">
                <td class="date-column">
                  {{ item.ProcessedDateStartDisplay }}
                </td>
                <td class="jobname-column">{{ item.JobName }}</td>
                <td class="date-column">{{ item.ProcessedDateEndDisplay }}</td>
                <td
                  :class="
                    item.Status == 'Success'
                      ? 'status-column green'
                      : 'status-column red'
                  "
                >
                  {{ item.Status }}
                </td>
                <td class="error-column">{{ item.ErrorMessage }}</td>
              </tr>

              <tr v-if="logs && !logs.length">
                <td colspan="5" class="text-center">{{ this.noRecordText }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="logs && logs.length">
      <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          logs.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
export default {
  data() {
    return {
      logs: [],
      jobName: "",
      dateFrom: "",
      dateTo: "",
      status: "",
      noRecordText: config.NO_RECORD_TEXT,
      //pagination
      paging: {
        Search: "",
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 100,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },
  watch: {
    "paging.SizePerPage": function (val, oldVal) {
      this.paging.CurrentPage = 1;
      this.getLogs();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    getLogs() {
      let param = {
        Token: this.token,
        JobName: this.jobName,
        DateFrom: this.dateFrom,
        DateTo: this.dateTo,
        Status: this.status,
        CurrentPage: this.paging.CurrentPage,
        TotalPage: this.paging.TotalPage,
        SizePerPage: this.paging.SizePerPage,
      };
      this.$store.state.isLoading = true;
      API.getSyncLogs(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.logs = response.data.record;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //pagination method
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getLogs();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getLogs();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getLogs();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getLogs();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getLogs();
    },
  },
  created() {
    if (this.role == "admin") this.getLogs();
  },
};
</script>

<style scoped>
.fit-content {
  max-width: fit-content;
}

.title-left {
  max-width: 110px;
}

.title-right {
  max-width: 70px;
}

.red {
  color: red;
}

.green {
  color: green;
}

.table-responsive {
  white-space: unset;
}

.table {
  width: 1800px;
}

.date-column {
  width: 13%;
}
.jobname-column {
  width: 20%;
}
.status-column {
  width: 7%;
}
</style>



// WEBPACK FOOTER //
// src/components/System/SyncLog.vue